import { render, staticRenderFns } from "./OrderOriginSelector.vue?vue&type=template&id=227b955f&"
import script from "./OrderOriginSelector.vue?vue&type=script&lang=js&"
export * from "./OrderOriginSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports